import { HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { UrlSerializer } from '@angular/router';
import { ModalModule } from 'ngx-bootstrap/modal';
import { UpplmModuleShared } from './app.module.shared';
import { AppRoutingModule } from './app.routes.module';
import { UpsUpplmComponent } from './components/app/app.component';
import { UpplmApiService } from './services/upplm.api.services';
import { UpsCommonService } from './services/upplm.common.service';
import { ConfigurationService } from './services/upplm.configuration.service';
import { CreatePickUpService } from './services/upplm.createPickUp.service';
import { UpsDashboardService } from './services/upplm.dashboard.service';
import { UpplmErrorHandlerService } from './services/upplm.errorHandler.service';
import { UpplmGenericDictionary } from './services/upplm.genericDictionary';
import { GoogleRequestService } from "./services/upplm.googleRequest.service";
import { IOBBService } from './services/upplm.iobb.service';
import { UpplmLocationDetailsService } from "./services/upplm.locationDetails.service";
import { LowerCaseUrlSerializer } from './services/upplm.lowerCaseUrlSerializer';
import { ProgressBarService } from './services/upplm.progressbar.service';
import { QVDashboardSearchService } from './services/upplm.qvDashboardSearch.service';
import { SendApproveService } from './services/upplm.sendApprove.service';
import { UpplmSessionService } from "./services/upplm.session.service";
import { TranslationService } from './services/upplm.translation.service';
import { UtagService } from './services/upplm.utag.service';
import { ScrollTopService } from './services/upplmScrollTop.service';
import { CommonUserAttributesService } from './services/upplm.commonUserAttributes.service';

export function init_app(appLoadService: UpsCommonService): () => Promise<any> {
    const result = () => appLoadService.initializeUPPLMApp();
    return result;
}
export function translationFactory(_translationService: TranslationService) {
    return () => _translationService.load();
}

@NgModule({
    bootstrap: [UpsUpplmComponent],
    imports: [
        BrowserModule,
        UpplmModuleShared,
        AppRoutingModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientXsrfModule.withOptions({
            cookieName: 'CV-XSRF-TOKEN',
            headerName: 'X-XSRF-TOKEN',
        }), ModalModule.forRoot(),

    ],
    providers: [
        { provide: 'BASE_URL', useFactory: getBaseUrl },
        UpplmApiService, UpplmErrorHandlerService, UpplmGenericDictionary, ScrollTopService, IOBBService, UtagService,
        UpsCommonService, UpplmSessionService, UpplmLocationDetailsService, GoogleRequestService, CreatePickUpService,
        ProgressBarService, SendApproveService, TranslationService, CommonUserAttributesService,
        { provide: APP_INITIALIZER, useFactory: init_app, deps: [UpsCommonService], multi: true },
        { provide: APP_INITIALIZER, useFactory: translationFactory, deps: [TranslationService], multi: true },
        { provide: UrlSerializer, useClass: LowerCaseUrlSerializer }, UpsDashboardService, QVDashboardSearchService, ConfigurationService,
      
    ],
    declarations: [UpsUpplmComponent
    ]
})
export class UpplmModule {
}

export function getBaseUrl() {
    return document.getElementsByTagName('base')[0].href;
}
